import type { FC } from 'react';
import { Button } from 'antd';
import { Link as LinkIcon } from 'lucide-react';
import type { Campaign } from './CampaignTable';

interface CampaignContentsTabProps {
  isEdit: boolean;
  campaign: Campaign | null;
}

const CampaignContentsTab: FC<CampaignContentsTabProps> = ({ isEdit, campaign }) => (
  <div className="mt-2 space-y-3">
    {isEdit ? (
      <>
        <p className="text-xs text-slate-500 dark:text-slate-400">
          {campaign!.contentsCount} contenu(s) lié(s) à cette campagne.
        </p>
        <Button size="small" icon={<LinkIcon className="h-3.5 w-3.5" />} disabled title="Disponible après LOT 31">
          Lier un contenu
        </Button>
        <p className="text-[10px] text-slate-400">
          POST /api/v1/admin/marketing/campaigns/{'{id}'}/contents — Liaison par calendarId ou blogArticleId
        </p>
      </>
    ) : (
      <p className="py-8 text-center text-sm text-slate-400">Sauvegardez la campagne pour lier des contenus</p>
    )}
  </div>
);

export default CampaignContentsTab;
